import React, { useState, useEffect } from "react";
import { Menu, X, ArrowRight } from "lucide-react";
import { NAV_LINKS } from "../data/site";

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="main-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? "glass shadow-sm" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <a href="#top" data-testid="brand-logo" className="flex items-center gap-3">
            <img
              src="/assets/babul-logo.jpeg"
              alt="Babul Corporation"
              className="h-11 w-11 rounded-full object-cover ring-1 ring-navy/10"
            />
            <div className="leading-tight">
              <div className="font-display text-lg md:text-xl text-navy font-bold">
                Babul Corporation
              </div>
              <div className="text-[10px] tracking-[0.2em] uppercase text-emerald font-semibold">
                Global Trade · Trusted Partnerships
              </div>
            </div>
          </a>

          <nav className="hidden lg:flex items-center gap-8">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`nav-link-${l.label.toLowerCase()}`}
                className="text-sm font-medium text-slate-700 hover:text-navy transition-colors"
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-3">
            <a href="#contact" data-testid="header-cta" className="btn-primary text-sm">
              Request a Quote <ArrowRight className="w-4 h-4" />
            </a>
          </div>

          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden p-2 rounded-lg hover:bg-slate-100"
            aria-label="Toggle menu"
          >
            {open ? <X className="w-6 h-6 text-navy" /> : <Menu className="w-6 h-6 text-navy" />}
          </button>
        </div>

        {open && (
          <div data-testid="mobile-menu" className="lg:hidden pb-6 pt-2 space-y-1 border-t border-slate-200">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${l.label.toLowerCase()}`}
                className="block px-3 py-3 rounded-lg text-slate-800 font-medium hover:bg-slate-50"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              data-testid="mobile-header-cta"
              className="btn-primary w-full mt-3"
            >
              Request a Quote
            </a>
          </div>
        )}
      </div>
    </header>
  );
}
